import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { Line } from "react-chartjs-2";
import { monthLabelList } from "./utils";
import "../../../styles/analytics/charts.scss";
import Modal from "../ui/Modal.jsx";

export const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      stacked: true,
      title: {
        display: false,
      },
      min: -100,
      max: 100,
    },
  },
  interaction: {
    intersect: false,
    mode: "index",
  },
  maintainAspectRatio: false,
};

const EmptyChartState = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box className="empty-chart">
      <Box className="empty-chart-container">
        <Box sx={{ height: "200px" }} className="empty-chart-content">
          <Line
            options={options}
            data={{
              labels: monthLabelList,
              datasets: [...Array(12).keys()].map(() => ({
                label: "",
                data: [],
                backgroundColor: "white",
                borderColor: "white",
              })),
            }}
          />
        </Box>
      </Box>
      <Stack
        spacing="20px"
        justifyContent="center"
        alignItems="center"
        sx={{ width: "100%" }}
        className="empty-chart-state"
      >
        <i
          className="fa fa-exclamation-triangle warning-icon"
          aria-hidden="true"
        ></i>

        <Box sx={{ textAlign: "center" }}>
          <Typography component="span" className="title">
            Data Not Available
          </Typography>
          <Box>
            <Typography component="span" className="sub-title">
              Currently unable to gather your data at this time.
            </Typography>
          </Box>
        </Box>

        <Box className="more-button" onClick={handleClickOpen}>
          <Typography component="span">Learn More</Typography>
        </Box>
      </Stack>

      <Modal
        open={open}
        onClose={handleClose}
        title="Why we are unable to show your data"
        content={
          <Box>
            <Box sx={{ marginBottom: "10px", marginTop: "20px" }}>
              <Typography
                component="span"
                sx={{ fontSize: "16px", fontWeight: 500 }}
              >
                We're currently unable to provide all your data. This might be
                due to a few reasons:
              </Typography>
            </Box>
            <Box>
              <Typography
                component="span"
                sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "22px" }}
              >
                1. We're gathering information for a profile you've recently set
                up.
                <br />
                2. We can't access data generated before you started your
                profile.
                <br />
                3. We can't collect data for profiles that aren't connected
                right now.
                <br />
                4. If a profile was disconnected at any point, we might miss
                some data from that period.
                <br />
                5. Today's data is still being processed; it can take a day to
                be fully available.
              </Typography>
            </Box>
          </Box>
        }
        action={{ label: "Done", onClick: handleClose }}
      />
    </Box>
  );
};

export default EmptyChartState;
